<script setup lang="ts">
import { useI18n } from 'vue-i18n';
// @ts-ignore
import { getCRMOrigin } from 'shared/helpers/env';
import OrderDetail from './OrderDetail.vue';
import OrderDetailMultiple from './OrderDetailMultiple.vue';
import { formatOrderDate } from '../utils';

import type { IOrderMessage } from './types';

const props = defineProps<{
  message: IOrderMessage;
}>();

const { t } = useI18n();

const { orderId, placeTime, showTotalAmount, itemList, labels } =
  props?.message ?? {};

const handleDetail = () => {
  window.open(`${getCRMOrigin()}/order-detail?orderId=${orderId}`);
};

const isSingleItem = itemList.length === 1;

const orderIdLabel =
  labels?.orderID ?? t('CONVERSATION.CARD_MESSAGE.ORDER.ORDER_ID');
const orderDateLabel =
  labels?.orderDate ?? t('CONVERSATION.CARD_MESSAGE.ORDER.ORDER_DATE');
const viewLabel = labels?.view ?? t('CONVERSATION.CARD_MESSAGE.VIEW_DETAILS');
</script>

<template>
  <div class="order-card">
    <div class="order-info">
      <div>{{ orderIdLabel }}: {{ orderId }}</div>
      <div>
        {{ orderDateLabel }}:
        {{ formatOrderDate(placeTime) }}
      </div>
    </div>
    <OrderDetail
      v-if="isSingleItem"
      :labels="labels"
      :detail="itemList[0]"
      :show-total-amount="showTotalAmount"
    />
    <OrderDetailMultiple
      v-else
      :list="itemList"
      :on-view-more="handleDetail"
      :labels="labels"
    />
    <div class="action-button" @click="handleDetail">
      {{ viewLabel }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.order-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
}

.order-info {
  line-height: 15px;

  & > div:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>
